import { useState } from 'react';
import { Button, styled } from '@mui/material';
import FullPageDrawer from 'components/new/FullPageDrawer';
import { useLayoutContext } from 'contexts/LayoutContext';
import { Column } from 'further-ui/components/Layout';
import InvestorSearch from './InvestorSearch';
import NewInvestorForm from './NewInvestorForm';

const Content = styled(Column)({
  maxWidth: 500,
  height: '100%',
  maxHeight: '100%',
});

type Props = {
  open: boolean;
  onClose: () => void;
};

const AddInvestor: React.FC<Props> = ({ open, onClose }) => {
  const { vehicle } = useLayoutContext();

  const [showNewInvestorForm, setShowNewInvestorForm] = useState(false);
  const [selectedInvestorId, setSelectedInvestorId] = useState<string | null>(
    null,
  );

  if (!open || !vehicle) return null;

  const handleBack = () => {
    if (showNewInvestorForm) {
      setShowNewInvestorForm(false);
    } else if (selectedInvestorId) {
      setSelectedInvestorId(null);
    } else {
      onClose();
    }
  };

  const handleShowNewInvestorForm = () => {
    setShowNewInvestorForm(true);
    setSelectedInvestorId(null);
  };

  const backButtonLabel =
    selectedInvestorId || showNewInvestorForm ? 'Back' : 'Cancel';

  return (
    <FullPageDrawer
      open={true}
      onClose={onClose}
      title="Add investor"
      actions={
        <Button
          variant="outlined"
          color="primary"
          size="large"
          onClick={handleBack}
        >
          {backButtonLabel}
        </Button>
      }
    >
      <Content spacing="xl" fullWidth justify="center">
        {showNewInvestorForm ? (
          <NewInvestorForm
            vehicleName={vehicle.vehicleName}
            vehicleId={vehicle._id}
            onClose={onClose}
          />
        ) : (
          <>
            <InvestorSearch
              selectedInvestorId={selectedInvestorId}
              onInvestorSelect={setSelectedInvestorId}
              onShowNewInvestorForm={handleShowNewInvestorForm}
              onClose={onClose}
              vehicle={vehicle}
            />
          </>
        )}
      </Content>
    </FullPageDrawer>
  );
};

export default AddInvestor;
